export default __webpack_public_path__ + "static/media/nimble-logo.6c7f17ff.svg";